import { Application } from "../Application/Application.js";
const application = new Application();
window.application = application;

const loader = document.querySelector('.loader');
const body = document.querySelector('body');

if (document.querySelectorAll('.loader').length)
{
	body.classList.add('loading');

	window.addEventListener('load', () => {
		setTimeout(() => {
			loader.classList.add('ready');
			body.classList.remove('loading');
			//showAd();
		}, 400);
		setTimeout(() => {
			if (animItems.length > 0) {
				animOnScroll();
				window.addEventListener('scroll', animOnScroll);
			}
		}, 800);
	});
}

const animItems = document.querySelectorAll('.animated-page .anim-item');

function animOnScroll(params) {
	for (let index = 0; index < animItems.length; index++) {
		const animItem = animItems[index];
		const animItemHeight = animItem.offsetHeight;
		const animItemOffsetTop = offset(animItem).top;
		const animStart = 3;

		let animItemPointY = window.innerHeight - animItemHeight / animStart;

		if (animItemHeight > window.innerHeight - window.innerHeight / animStart) {
			animItemPointY = window.innerHeight - window.innerHeight / animStart;
		}

		if(pageYOffset > animItemOffsetTop - animItemPointY && pageYOffset < animItemOffsetTop + animItemHeight) {
			animItem.classList.add('active');
		} else {
			if (!animItem.classList.contains('anim-item--no-hide')) {
				animItem.classList.remove('active');
			}
		}
	}
};

function offset(el) {
	const rect = el.getBoundingClientRect(),
	scrollTop = window.pageYOffset || document.documentElement.scrollTop,
	scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
};

// App heights
const doc = document.documentElement
const header = document.querySelector(".header");
const programNav = document.querySelector(".program__nav");
const appHeights = () => {
	if (header) {
		let headerHeight = header.offsetHeight;
		doc.style.setProperty('--header-height', headerHeight + "px");
	}
	if (programNav) {
		let programNavHeight = programNav.offsetHeight;
		doc.style.setProperty('--program-nav-height', programNavHeight + "px");
	}
}
appHeights();


let v = $(window).height();

$(window).on("scroll", function () {
	appHeights();

	if ($(this).scrollTop() > 0) {
		$(".header").addClass("scrolled");
	} else {
		$(".header").removeClass("scrolled");
	};

	if($('.promo').length)
	{
		let h = $('.promo__image').height();
		let s = $(window).scrollTop();

		let begin = $('.promo').offset().top + h - v;
		let end = $('.promo').offset().top;


		if (s > begin && s < end)
		{
			var o = ((s - begin) / (end - begin) * 100) + '%';
		}
		//console.log(v + ' ' + p + ' ' + h + ' ' + s + ' ' + o);

		$('.promo__image').css('background-position-y', o);


	}

	setBodyPadding();

	if($(".program__nav").length) {
		checkProgramNavSticky();
		setProgramItemAdditional();
		checkProgramNavScrolled();
	};

	if($(".application-form__nav").length) {
		setApplicationFormNav()
	};
});

$(window).on("resize", function () {
	appHeights();

	setBodyPadding();

	if (window.matchMedia("(min-width: 1024px)").matches) {
		if ($(".main-nav__menu").hasClass("active")) {
			$(".main-nav__toggler").removeClass("active");
			$(".main-nav__menu").removeClass("active");
		}
		$(".main-nav__menu").removeAttr("style");
	}

	if($(".program__nav").length) {
		checkProgramNavSticky();
		setProgramItemAdditional();
		checkProgramNavScrolled();
	};

	if($(".application-form__nav").length) {
		setApplicationFormNav()
	};
});

function setBodyPadding() {
	$("body").css("padding-top", $(".header").outerHeight());
};

setBodyPadding();

$('a[href^="#"]').click(function () {
	let elementClick = $(this).attr("href").replace(/.*#/, '');
	if (elementClick && $('a[name='+elementClick+']').length)
	{
		let destination = $('a[name='+elementClick+']').offset().top
		destination -= $(".header").outerHeight();
		if ($(".program__nav").length)
			destination -= $(".program__nav").outerHeight();
		if ($(".application-form__nav").length)
			destination -= $(".application-form__nav").outerHeight();

		console.log(destination);
		$('html, body').animate( { scrollTop: destination }, 1100 );
	}
});

$(document).on("ready", function () {
	appHeights();

	if (window.location.hash.match(/#.+/))
	{
		let elementClick = window.location.hash.replace(/.*#/, '');
		if (elementClick && $('a[name='+elementClick+']').length)
		{
			let destination = $('a[name='+elementClick+']').offset().top
			destination -= $(".header").outerHeight();
			if ($(".program__nav").length)
				destination -= $(".program__nav").outerHeight();
			if ($(".application-form__nav").length)
				destination -= $(".application-form__nav").outerHeight();
			$('html, body').scrollTop(destination);
		}
	}
});

function checkProgramNavSticky() {
	var programNavRect = document.querySelector(".program__nav").getBoundingClientRect();
	if (programNavRect.top <= $(".header").outerHeight()) {
		$(".program__nav").addClass("scrolled");
	} else {
		$(".program__nav").removeClass("scrolled");
	}
};

function checkProgramNavScrolled() {
	if ($(".program-nav__list").innerWidth() >= $(window).innerWidth()) {
		$(".program-nav__chevron").show();
	} else {
		$(".program-nav__chevron").hide();
	}
};

function scrollToActiveProgramNav(elem) {
	$(".program-nav__item-btn").removeClass("active");
	$(elem).addClass("active");

	if ($(elem).attr('data-type')) {
		let dt = $(elem).attr('data-type');
		$('li.program-table__item').not('.program-item-first-day').each(function () {
			if ($(this).find('.program-item__tags-item[data-type=' + dt + ']').length)
				$(this).slideDown();
			else
				$(this).slideUp();
		});
	}
	else {
		$('li.program-table__item').not('.program-item-first-day').slideDown();
	}

	if ($(elem).offset().left + $(elem).innerWidth() > $(".container").offset().left + $(".container").innerWidth() || $(elem).offset().left < $(".container").offset().left)  {
		$(".program-nav__list").animate( { scrollLeft: $(elem).offset().left + $(elem).outerWidth(true) / 2 + $('.program-nav__list').scrollLeft() - $('.program-nav__list').outerWidth() / 2 }, 400 );
	}

	let destination = $('.program').offset().top - $(".header").outerHeight() + parseInt($(".program").css("padding-top"));
	$('html, body').animate( { scrollTop: destination }, 500 );
};

$(".program-nav__item-btn").click(function(){
	scrollToActiveProgramNav(this);
});

function setProgramItemAdditional() {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		$(".program-item__additional").each(function() {
			if($(this).outerHeight() <= $(window).innerHeight() - ($(".header").outerHeight() + $(".program__nav").outerHeight() + parseInt($(".program-item__content").css("padding-top")) * 2)) {
				$(this).addClass("sticky");
			} else {
				$(this).removeClass("sticky");
				$(this).removeAttr("style");
			}
		})
	}
};

if($(".program__nav").length) {
	checkProgramNavSticky();
	setProgramItemAdditional();
	checkProgramNavScrolled();
};

$(".main-nav__toggler").click(function (){
	$(this).toggleClass("active");
	$(".main-nav__menu").fadeToggle();
	$(".main-nav__menu").toggleClass("active");
});

// Popup
$(".popup__close, .popup__btn-close").click(function(e){
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").click(function(e) {
	var callbackPopup = $(".popup__container")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

let gallery = document.querySelector(".gallery")
if (gallery) {
	var swiperCards = new Swiper('.gallery__container', {
		slidesPerView: 'auto',
		loop: true,
		centeredSlides: true,
		spaceBetween: 16,
		navigation: {
			nextEl: '.gallery__nav--next',
			prevEl: '.gallery__nav--prev'
		},
		pagination: {
			el: '.gallery__pagination-container',
			clickable: true,
			bulletElement: "button type='button'",
			bulletClass: 'gallery__pagination-bullet',
			bulletActiveClass: 'gallery__pagination-bullet--active',
		},
		breakpoints: {
			768: {
				spaceBetween: 24
			},
			1280: {
				spaceBetween: 32
			},
			1360: {
				spaceBetween: 40
			}
		}
	});
}

$(".program-item__certificate-btn").click(function (){
	$(this).siblings(".program-item__certificate-info").fadeToggle();
});

$(".program-item__certificate-info-close").click(function (){
	$(this).parent(".program-item__certificate-info").fadeOut();
});

$(document).click(function(e) {
	if ($(".program-item__certificate-info").is(":visible")) {
		var callbackPopup = $(".program-item__certificate-info, .program-item__certificate-btn")
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".program-item__certificate-info").fadeOut();
		};
	}
});

$(".program-item__full-description-more").click(function (){
	$(this).text(function(i, v){
		return v === 'Смотреть подробное описание' ? 'Скрыть подробное описание' : 'Смотреть подробное описание'
	});
	$(this).siblings(".program-item__full-description-text").slideToggle();
});

$(".application-types__item-input").change(function(){
	if($(".application-types__item-input--aud").is(":checked")) {
		$(".application__form--online").hide();
		$(".application__form--aud").fadeIn();
		$(".application__teaser-price--online").hide();
		$(".application__teaser-price--aud").fadeIn();
	}

	if($(".application-types__item-input--online").is(":checked")) {
		$(".application__form--aud").hide();
		$(".application__form--online").fadeIn();
		$(".application__teaser-price--aud").hide();
		$(".application__teaser-price--online").fadeIn();
	}
});

$('.about-prices__discouts-input').change(function(){
	let d = $(this).val();

	$('.about-prices__subitem').each(function(){
		let p = $(this).attr('data-price');
		if (p)
		{
			p = Math.round(p * (100 - d) / 100);
			$(this).find('b').text(p + '  руб');
		}
	});
});

function setApplicationFormNav() {
	$(".application-form__nav").css("top", $(".header").outerHeight());
};

if($(".application-form__nav").length) {
	setApplicationFormNav()
};

$(".application-finish__participant-input").change(function(){
	if($(this).closest(".application-finish__participant-list").find(".application-finish__participant-input--person").is(":checked")) {
		$(this).closest(".application-finish__participant").siblings(".application-finish__company").slideUp();
	}

	if($(this).closest(".application-finish__participant-list").find(".application-finish__participant-input--company").is(":checked")) {
		$(this).closest(".application-finish__participant").siblings(".application-finish__company").slideDown();
	}
});

$(".application-discount__item-input[name='order_discounts_id114']").on("change", function(){
	if($(this).is(":checked")) {
		$(".application-discount__item-org").slideDown();
	} else {
		$(".application-discount__item-org").slideUp();
	}
});

function calcSum(form, input = null) {
	let checkDiscount = 0;

	if (input && input.hasClass('application-discount__item-input') && input.attr('data-verif-type') > 0 && input.prop('checked'))
	{
		checkDiscount = input.attr('data-verif-type');
		$('.application-form__step-loader').addClass('active');
	}

	$.ajax({
		url: "/ajax.php?mid=51",
		type: 'POST',
		data: form.serialize() + '&action=calcSum',
		dataType: "json",
		success: function(res){
			if (checkDiscount || ($('.input-promo').length && $('.input-promo').val() != '') || ($('.input-sert').length && $('.input-sert').val() != ''))
			{
				$('.application-form__step-loader').removeClass('active');
				
				let errorText1 = '';
				let errorText2 = '';
				
				if (res.fault_promocode_count)
				{
console.log('err promo');
					errorText1 += 'Мы не смогли найти указанный Вами промокод!\n';
					errorText2 += 'Убедитесь, пожалуйста, что Вы указали верный промокод!\n';
				}	

				if (res.fault_sert_count)
				{
console.log('err sert');
					errorText1 += 'Мы не смогли найти указанный Вами сертификат!\n';
					errorText2 += 'Убедитесь, пожалуйста, что Вы указали верный номер сертификата!\n';
				}					
				
				if (res.fault_discount_count)
				{
					input.prop('checked', false);
					$('.popup-discount-error').addClass('active');

					if (checkDiscount == 1)
					{
						errorText1 += 'Мы\u00A0не\u00A0смогли подтвердить Ваше участие в\u00A0текущем Национальном конкурсе «Золотая Психея». Участие в\u00A0Конкурсе в\u00A0прошлые годы не\u00A0является основанием для этой скидки.';
						errorText2 += 'Убедитесь, пожалуйста, что\u00A0Вы указываете такие\u00A0же персональные данные, что и\u00A0в\u00A0конкурсной заявке.';
					}
					else if (checkDiscount == 2)
					{
						errorText1 += 'Мы\u00A0не\u00A0смогли подтвердить Ваше участие в\u00A0Саммитах и/или Зимних фестивалях прошлых лет.';
						errorText2 += 'Убедитесь, пожалуйста, что\u00A0Вы указываете такие\u00A0же персональные данные, что и\u00A0при участии в\u00A0Саммите и/или Фестивале.';
					}
					else if (checkDiscount == 3)
					{
						errorText1 += 'Мы\u00A0не\u00A0смогли подтвердить Ваш статус студента или выпускника программ дополнительного профессионального образования Института «Иматон»';
						errorText2 += 'Убедитесь, пожалуйста, что\u00A0Вы указали такие\u00A0же персональные данные, что и\u00A0при обучении в\u00A0Институте.';
					}
				}	
					
				if (res.fault_discount_count || res.fault_promocode_count || res.fault_sert_count){	
					$('.popup-discount-error .popup-discount__message-text1').text(errorText1);
					$('.popup-discount-error .popup-discount__message-text2').text(errorText2);
					
					$('.popup-discount-error').addClass('active');					
					$("body").addClass("no-scroll");
				}
				else
				{
					$('.popup-discount-success').addClass('active');
					$("body").addClass("no-scroll");
				}
			}

			console.log(res);
			let rs = form.find('.application-finish__summary-content');
			rs.html('');
			rs.append('<div class="application-finish__summary-row"></div>')
			rs.children().last()
			.append('<span class="application-finish__summary-item">Оргвзнос участника:</span>')
			.append('<span class="application-finish__summary-item">' + res.mainSum + ' руб.</span>');
			if (res.discounts.length)
			{
				let d = res.discounts[0];
				let name = d.name + (d.mode == '%' ? ' ' + d.amount + '%' : '');
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
				.append('<span class="application-finish__summary-item">'+ name + ':</span>')
				.append('<span class="application-finish__summary-item">' + d.sum + ' руб.</span>');
			}

			if (res.sputSum)
			{
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
				.append('<span class="application-finish__summary-item">Программы спутники:</span>')
				.append('<span class="application-finish__summary-item">' + res.sputSum + ' руб.</span>');
			}

			if (res.optsSum)
			{
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
				.append('<span class="application-finish__summary-item">Теплоходная прогулка:</span>')
				.append('<span class="application-finish__summary-item">' + res.optsSum + ' руб.</span>');
			}

			if (res.mkSum)
			{
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
				.append('<span class="application-finish__summary-item">Удостоверения за мастер-классы:</span>')
				.append('<span class="application-finish__summary-item">' + res.mkSum + ' руб.</span>');
			}

			rs.append('<div class="application-finish__summary-row"></div>')
			rs.children().last()
			.append('<span class="application-finish__summary-item"><strong>Итого</strong></span>')
			.append('<span class="application-finish__summary-item"><strong>' + res.sum + ' руб.</strong></span>');
		},
		error: function(err){}
	});
};

function syncInput(el)
{
	let form = $(el[0].form);
	let targetForm;
	if (form.hasClass('application__form--aud'))
		targetForm = $('.application__form--online');
	else
		targetForm = $('.application__form--aud');

	let name = el.attr('name');
	let type;
	if (el.prop("tagName") == 'SELECT')
		type = 'select';
	else
		type = el.attr('type');

	let targetInput = targetForm.find('input[name = ' + name +']');

	if (type == 'select')
	{
		targetInput = targetForm.find('select[name = ' + name +']');
		targetInput.val(el.val());
	}
	else if (type == 'checkbox')
	{
		targetInput.prop('checked', el.prop('checked'));
	}
	else if (type == 'radio')
	{
		targetInput.filter('[value=' + el.val() + ']').prop('checked', true);
	}
	else
	{
		targetInput.val(el.val());
	}

}

function orderMk(parent, id)
{
	let orderId = $('.trans-personal__content input[name=order_id]').val();
	let clientId = $('.trans-personal__content input[name=client_id]').val();
	let secret = $('.trans-personal__content input[name=secret]').val();

	$.ajax({
		url: "/ajax.php?mid=51",
		type: 'POST',
		data: {action: 'order_mk', orderId: orderId, clientId: clientId, secret: secret, id: id},
		dataType: "json",
		async: false,
		success: function(res){
			if (res.success)
			{
				parent.attr('href', res.payURL);
				window.open(res.payURL, '_blank');
			}
			else
			{
				alert(res.error);
			}
		},
		error: function(err){}
	});
}

$('.order_mk_button').click(function(){
	let el = $(this);
	orderMk(el, el.attr('data-id'));
});

$('.application__form').on('change', 'input, select', function(){
	calcSum($(this.form), $(this));
	syncInput($(this));
});

$('.input-promo').on('change', 'input, select', function(){
	calcSum($(this.form), $(this));
	syncInput($(this));
});

$('.input-sert').on('change', 'input, select', function(){
	calcSum($(this.form), $(this));
	syncInput($(this));
});

if ($(".application__form--aud").length > 0) {
	
	calcSum($('.application__form--aud'));
}
if ($(".application__form--online").length > 0) {

	calcSum($('.application__form--online'));
}

if (window.location.hash == '#online')
{
	$('.application-types__item-input--online').prop('checked', true).trigger('change');
}

function setcookie(name, value, expires, path, domain, secure) {	// Send a cookie
	//
	// +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)

	expires instanceof Date ? expires = expires.toGMTString() : typeof(expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
	var r = [name + "=" + escape(value)], s, i;
	for(i in s = {expires: expires, path: path, domain: domain}){
		s[i] && r.push(i + "=" + s[i]);
	}
	return secure && r.push("secure"), document.cookie = r.join(";"), true;
};
// возвращает cookie если есть или undefined
function getcookie(name) {
	var matches = document.cookie.match(new RegExp(
	  "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	))
	return matches ? decodeURIComponent(matches[1]) : undefined
};

if (!getcookie('cookieAccepted')) {
	$(".cookie").addClass('active');
}

$('.cookie__btn').on("click", function () {
	setcookie('cookieAccepted', 1, 60 * 60 * 24 * 365, '/');
	$(".cookie").removeClass('active');
});


/*
function showAd()
{
	if (!getcookie('popup-free_showed'))
	{
		$('body').addClass('no-scroll')
		$('.popup-free').addClass('active');
		setcookie('popup-free_showed', 1, 60 * 60 * 4, '/');
	}
}

if (window.location.pathname != '/summit/' && window.location.pathname != '/summit/trans/')
{
	$(document).ready(function(){
		showAd();
	})
}
*/
